import React, { useState } from "react";
import { Button, Modal, message } from "antd";
import PwModal from "./change-password";
import { lib } from "react-single-app";

/**
 * 密码需要修改提示
 * @constructor
 */
export default function HintChangePassword({ visible, onHandle, jumpPage }) {
    const [pwVisible, setPwVisible] = useState(false);
    const [role, setRole] = useState(localStorage.getItem("role"));
    const handleNoNeedChange = () => {
        noNeedChange();
        onHandle("noNeedChange");
    };
    const handleNextChange = () => {
        onHandle("nextChange");
        jumpPage();
    };
    const handleToChange = () => {
        if (role === "admin") {
            setPwVisible(true);
            onHandle("toChange");
        } else {
            getUserInfo();
        }
    };
    function noNeedChange() {
        lib.request({
            url: "/ucenter-account/current/ignoreUpdatePwd",
            success: res => {
                jumpPage();
            },
        });
    }
    const getUserInfo = () => {
        lib.request({
            url: "/ucenter-account/current/userDetails",
            needMask: true,
            success: res => {
                if (res.allowUpdatePwd) {
                    setPwVisible(true);
                    onHandle("toChange");
                } else {
                    message.warning("仅账号密码方式登录的才可以使用该功能");
                }
            },
        });
    };
    return (
        <>
            <Modal
                visible={visible}
                title={"提示"}
                onCancel={() => {
                    onHandle("nextChange");
                }}
                footer={[
                    <Button key="noNeedChange" onClick={handleNoNeedChange}>
                        无需修改
                    </Button>,
                    <Button key="nextChange" onClick={handleNextChange}>
                        下次修改
                    </Button>,
                    <Button key="toChange" type="primary" onClick={handleToChange}>
                        去修改
                    </Button>,
                ]}>
                <p>您的帐号已经登录超过90天了,为了您的账号安全建议您修改您的密码</p>
            </Modal>
            <PwModal
                pwVisible={pwVisible}
                onClose={success => {
                    jumpPage();
                    setPwVisible(false);
                }}
            />
        </>
    );
}
